<div class="user-management-layout">
  <div class="user-list-column">
    <div class="column-header">
      <app-rfebm-primary-button (click)="openCreateUserModal()">
        <!-- <span class="icon"></span> -->
        Crear Usuario
      </app-rfebm-primary-button>
    </div>
    <app-user-list
      [users]="users$ | async"
      (userSelected)="onUserSelected($event)">
    </app-user-list>
  </div>

  <div class="permission-editor-column">
    <app-permission-editor
      [selectedUser]="selectedUser"
      (permissionsSaved)="onPermissionsSaved()"
      (userDeleted)="onPermissionsSaved()">
    </app-permission-editor>
  </div>
</div>
